import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import "./AddServices.css";

const AddServices = () => {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    console.log(data);

    axios
      .post("https://ancient-harbor-24674.herokuapp.com/services", data)
      .then((res) => {
        if (res.data.insertedId) {
          alert("Successfully added your service.");
          reset();
        }
      });
  };
  return (
    <div className="add-service border rounded-5 m-auto mt-5 container mb-5  col-md-12">
      <h2 className="mt-5">Please Add a tour</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="">
        <input
          className="w-50 col-md-12 p-2"
          type="text"
          {...register("name", { required: true, maxLength: 20 })}
          placeholder="Name"
        />
        <br />
        <textarea
          type="text"
          rows="10"
          required
          className="w-50 mt-3 col-md-12 p-2"
          {...register("description")}
          placeholder="Write a description about place or tour"
        />
        <br />
        <input
          required
          className="mt-3 w-50 col-md-12 p-2"
          type="number"
          {...register("price")}
          placeholder="Price"
        />
        <br />
        <input
          required
          className="mt-3 w-50 col-md-12 p-2"
          type="number"
          {...register("days")}
          placeholder="Days"
        />
        <br />
        <input
          required
          className="mt-3 w-50 col-md-12 p-2"
          type="url"
          {...register("img")}
          placeholder="Image URL"
        />
        <br />
        <input className="btn btn-outline-primary mt-5 mb-5" type="submit" />
      </form>
    </div>
  );
};

export default AddServices;
